<template>
    <div class="cursor">
        <div id="js-cursor" class="cursor__circle" ref="cursor">
            <svg height="10" width="10">
            <circle cx="5" cy="5" r="5" stroke-width="0"></circle>
            </svg>
            <span class="cursor__txt">VIEW</span>
        </div>
        <div class="overlay" id="js-overlay"></div>
    </div>
</template>


<script>
import gsap from 'gsap'

  export default {
    name: 'MouseCursor',
    methods: {
      init: function() {
        const { cursor } = this.$refs

        gsap.set(cursor, {
            css: {
                left: this.left,
                top: this.top
            }
        });
      },
      mouseMove: function(e) {
         const { cursor } = this.$refs
         let
                mouseX = -5,
                mouseY = -5;
                mouseX = e.clientX;
                mouseY = e.clientY;
                this.left = mouseX;
                this.top = mouseY;
        if (cursor) {
          gsap.to(cursor, .3, {
              css: {
                  left: this.left,
                  top: this.top
              },
              ease: 'power2.ease',
          });
        }

      },
      mouseZoom: function() {
        let cursor = document.getElementById('js-cursor');
        cursor.classList.add("is-active");
        gsap.to(cursor, .25, {
            css: {
                width: 40,
                height: 40
            }
        });
      },
      mouseZoomPt1: function() {
        let cursor = document.getElementById('js-cursor');
        cursor.classList.add("is-active-pt1");
        gsap.to(cursor, .25, {
            css: {
                width: 80,
                height: 80
            }
        });
      },
      mouseZoomOut: function() {
        let cursor = document.getElementById('js-cursor');
        cursor.classList.remove("is-active");
        cursor.classList.remove("is-active-pt1");
        gsap.to(cursor, .25, {
            css: {
                width: 10,
                height: 10
            }
        });
      },
      mouseHrefClick: function() {
        const { cursor } = this.$refs;
        let tl = gsap.timeline();

        tl.to(cursor, {
            duration: .15,
            css: {
                width: 60,
                height: 60
            }
        })
        .to(cursor, .35, {
            duration: .35,
            css: {
                width: 10,
                height: 10
            }
        });
      },
      mouseOverlay: function() {
        let overlay = document.getElementById('js-overlay');
        let sW = window.innerWidth;
        let sH = window.innerHeight;
        let oX = Math.ceil(sW / 2);
        let oY = Math.ceil(sH / 2);
        let x = this.left - oX;
        let y = -(this.top - oY);

        let pX,pY;
        if (x <= -1 && 1 <= y) {
          pX = oX;
          pY = -oY;
        }
        if (x >= 1 && 1 <= y) {
          pX = -oX;
          pY = -oY;
        }
        if (x >= 1 && -1 >= y) {
          pX = -oX;
          pY = oY;
        }
        if (x <= -1 && -1 >= y) {
          pX = oX;
          pY = oY;
        }
        let distance = Math.sqrt(Math.pow((x-pX), 2) + Math.pow((y-pY), 2) );
        let scale = Math.floor((distance/10)*2) + 10;

        const { cursor } = this.$refs;
        let tl = gsap.timeline();

        cursor.classList.remove("is-active-pt1");

        tl.to(cursor, {
            duration: .15,
            css: {
                width: 60,
                height: 60
            }
        })
        .to(cursor, {
            duration: .2,
            css: {
                width: 10,
                height: 10
            }
        });

        tl.set(overlay, {
            scale: 1,
            css: {
                left: this.left,
                top: this.top
            }
        })
        .to(overlay, {
            duration: .7,
            scale: scale,
            opacity: 1,
            ease: 'power2.easeOut'
        })
        .set(overlay, {
            scale: 0
        });
      },
      mouseBtnClick: function() {
        const { cursor } = this.$refs
        let tl = gsap.timeline();

        tl.to(cursor, {
            duration: .15,
            css: {
                width: 60,
                height: 60
            }
        })
        tl.to(cursor, {
            duration: .1,
            css: {
                width: 40,
                height: 40
            }
        });
      },
      mouseHover: function() {
        let self = this;
        document.querySelectorAll('a, button, .works-cat__item:not(.is-active) .js-btn, .js-pagetop').forEach(function(el) {
            if (el.classList.contains('js-cursor-pt1') == true ) {

              el.addEventListener('mouseover', self.mouseZoomPt1);
            } else {
              el.addEventListener('mouseover', self.mouseZoom);
            }
            el.addEventListener('mouseout', self.mouseZoomOut);
        });

        document.querySelectorAll('a:not([target="_blank"]), .works-cat__item:not(.is-active) .js-btn').forEach(function(el) {
          if (el.classList.contains('js-btn') == false ) {
            el.addEventListener('click', self.mouseOverlay);
          } else {
            el.addEventListener('click', self.mouseHrefClick);
          }
        });
        document.querySelectorAll('button, .js-pagetop').forEach(function(el) {
            el.addEventListener('click', self.mouseBtnClick);
        });
      },
      mouseHoverDestroy: function() {
        let self = this;
        self.mouseZoomOut();
        document.querySelectorAll('a, button, .works-cat__item .js-btn, .js-pagetop').forEach(function(el) {
            el.removeEventListener('mouseover', self.mouseZoom);
            el.removeEventListener('mouseover', self.mouseZoomPt1);
            el.removeEventListener('mouseout', self.mouseZoomOut);
            el.removeEventListener('click', self.mouseHrefClick);
            el.removeEventListener('click', self.mouseOverlay);
        });
      }
    },
    mounted() {
        let self = this;
        window.removeEventListener('mousemove', self.mouseMove);
        window.addEventListener('mousemove', self.mouseMove);
    },
    destroyed() {
      this.mouseHoverDestroy();
    },
    watch: {
        '$route' () {
          setTimeout(() => {
          this.mouseZoomOut();
        }, 200);

        }
    }
  }
</script>


<style lang="scss" scoped>
.overlay {
  overflow: hidden;
  position: fixed;
  top: -20px;
  left: 20px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  z-index: 1001;
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    background: #f5f4f9;
    border-radius: 50%;
    transform: translate(-50%,-50%);
    z-index: 1;
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 130%;
    height: 130%;
    background: rgba(155, 155, 155, 0.2);
    border-radius: 50%;
    transform: translate(-50%,-50%);
  }
}
</style>
